module.exports = __webpack_public_path__ + "assets/img/benefices-ged.e32007d5.png";